// extracted by mini-css-extract-plugin
export var blue = "_11-g";
export var brand = "_11-c";
export var darkGrey = "_11-f";
export var disabled = "_11-6";
export var disabledSubtle = "_11-7";
export var error = "_11-8";
export var green = "_11-h";
export var grey = "_11-e";
export var icon = "_11-0";
export var inherit = "_11-b";
export var lightGrey = "_11-d";
export var orange = "_11-j";
export var pink = "_11-l";
export var primary = "_11-1";
export var purple = "_11-m";
export var quaternary = "_11-4";
export var quinary = "_11-5";
export var red = "_11-k";
export var secondary = "_11-2";
export var success = "_11-a";
export var tertiary = "_11-3";
export var warning = "_11-9";
export var white = "_11-n";
export var yellow = "_11-i";